export default __webpack_public_path__ + "static/tokenomics_quick-44a71a91e748330878b551389678e077.png";